module.exports = __webpack_public_path__ + "img/duke-energy-logo.50c42562.jpg";